import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Subscription } from 'rxjs';
import { MainService } from 'src/app/services/main/main.service';
import { GlobalFilterObj, ALL_LOCATIONS_FILTER, GlobalFilterService } from 'src/app/services/shared/global-filter.service';
import moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { SignatureNewComponent } from 'src/app/shared/signature-new/signature-new.component';
import { getUserProfiles, getStoredLocations } from 'src/app/core/session';

@Component({
  selector: 'app-agreement',
  templateUrl: './agreement.component.html',
  styleUrls: ['./agreement.component.scss']
})
export class AgreementComponent implements OnInit {
  locationSubscription: Subscription;
  salutations_subscription: Subscription;
  selected_location: GlobalFilterObj = { ...ALL_LOCATIONS_FILTER };
  clinic = {
    doctor_name: null,
    doctor_date_display: null,
    doctor_address: null,
    doctor_city: null,
    doctor_state: null,
    doctor_zip: null,
    doctor_email: null,
    doctor_mobile: null,
    doctor_signature: null,
    manual_form_link: null,
    clinic_name: null,
    doctor_salutation: null,
    doctor_title: null
  };
  vendor = {
    current_date: new Date(),
    support_salutation: '',
    vendor_name: null,
    vendor_title: null,
    vendor_date_display: null,
    vendor_sign: null,
    support_signature: null,
    vendor: null
  }
  applyingBaa;
  form_status;
  signatureField;
  salutations = [];
  canvasWidth;
  userProfileData = localStorage.getItem('userProfileData') ? getUserProfiles() : [];
  show_sign = false;
  change_bsa_hsa_name = 0;
  support_name = 'Michael Jones';
  @ViewChildren(SignatureNewComponent) public sigs: QueryList<SignatureNewComponent>;
  @ViewChildren('sigContainer1') public sigContainer1: QueryList<ElementRef>;
  queryParamSubscription: any;
  ac_tk: any;
  constructor(private globalFilterService: GlobalFilterService, private mainService: MainService, public _routes: ActivatedRoute, public _router: Router) {
    let locationFilter = this.globalFilterService.getFilterObj('location');
    this.selected_location = locationFilter;
    if (this.userProfileData.length > 0 && this.userProfileData[0].role_id == 4) {
      this.selected_location = this.userProfileData[0];
      this.selected_location.id = this.selected_location['doctor_id'];
    }
  }

  ngOnInit() {
    let currentPath = window.location.pathname;
    this.salutations = this.mainService.salutation;
    this.salutations_subscription = this.mainService.salutations.subscribe((data: any) => {
      this.salutations = data;
    });
    if (this.userProfileData.length > 0) {
      let registration_date = new Date(this.userProfileData[0].date_registered);
      let static_date = new Date('2023-05-10 00:00:00');
      if (registration_date < static_date) {
        this.change_bsa_hsa_name = 1
      } else {
        this.change_bsa_hsa_name = 0;
      }
    }
    if (currentPath.indexOf("agreementForm?ac_tk") !== -1) {
      this.locationSubscription = this.globalFilterService.locationFilter
        .subscribe((filter) => {
          this.selected_location = filter;
        });
      if (this.userProfileData.length > 0 && this.userProfileData[0].role_id != 4) {
        let locId = this._routes.snapshot.queryParams.locId
        let locations = getStoredLocations();
        let location = locations.filter(location => location.doctor_id == locId);
        if (locId && location && location.length > 0) {
          this.selected_location = location[0];
          this.selected_location.id = location[0].doctor_id;
          this.getFormDetails();
        } else {
          this._router.navigate(['/app/help/support']);
        }
      } else {
        this.getFormDetails();
      }
    } else {
      this.ac_tk = this._routes.snapshot.queryParams.ac_tk;
      this.getFormDetails();
    }
  }

  getFormDetails() {
    let data = {
      access_token: this.ac_tk || localStorage.getItem('token'),
      doctor_id: this.userProfileData.length > 0 && this.userProfileData[0].role_id == 4 ? this.userProfileData[0].doctor_id : (this.selected_location ? this.selected_location.id : '')
    }
    this.mainService.api(data, `get_baa_form_details?lang=${this._routes.snapshot.queryParams['lang'] || 'en'}`, true)
      .subscribe((data: any) => {
        if (data && data.data && data.data[0] && data.data[0].form_status !== null && data.data[0].automatic !== null) {
          this.form_status = data.data[0].form_status;
          this.clinic = data.data[0];
          this.support_name = this.form_status == 3 ? data.data[0].support_name : 'Michael Jones';
          if (this.ac_tk) {
            this.selected_location = {
              type: 'location',
              name: '',
              id: -1,
              ind_id: data.data[0].ind_id,
              bsa_form_type: data.data[0].bsa_form_type
            }
          }
          if (data.data[0].automatic == 0) {
            this.applyingBaa = 2;
            this.clinic = {
              clinic_name: data.data[0].doctor_clinic_name,
              doctor_name: data.data[0].doctor_name || data.data[0].doctor_clinic_name,
              doctor_title: data.data[0].doctor_title,
              doctor_date_display: moment(new Date(data.data[0].doctor_date)).format("MM/DD/yyyy"),
              doctor_signature: data.data[0].doctor_signature,
              doctor_salutation: data.data[0].doctor_salutation,
              doctor_address: data.data[0].doctor_address || this.userProfileData[0] && this.userProfileData[0]['practice_address'],
              doctor_city: data.data[0].doctor_city || this.userProfileData[0] && this.userProfileData[0]['city'],
              doctor_state: data.data[0].doctor_state || this.userProfileData[0] && this.userProfileData[0]['state_name'],
              doctor_zip: parseInt(data.data[0].doctor_zip) || this.userProfileData[0] && this.userProfileData[0]['zip'],
              doctor_email: data.data[0].doctor_email || this.userProfileData[0] && this.userProfileData[0]['practice_email'],
              doctor_mobile: data.data[0].doctor_mobile || this.userProfileData[0] && this.userProfileData[0]['practice_mobile'],
              manual_form_link: null
            };
            if (data.data[0].form_status == 3) {
              this.applyingBaa = 4;
              this.vendor = {
                vendor: data.data[0].vendor,
                vendor_name: data.data[0].support_name,
                vendor_title: data.data[0].support_title,
                vendor_date_display: moment(new Date(data.data[0].support_date)).format("MM/DD/yyyy"),
                support_signature: data.data[0].support_signature,
                support_salutation: data.data[0].support_salutation || '',
                current_date: data.data[0].date_added,
                vendor_sign: null,
              };
            }
            if (data.data[0].doctor_date) {
              this.vendor['current_date'] = data.data[0].doctor_date;
            } else if (data.data[0].form_status == 3) {
              this.vendor['current_date'] = data.data[0].support_date;
            }
          } else {
            this.applyingBaa = 3;
            if (data.data[0].form_status == 3) {
              this.clinic['manual_form_link'] = data.data[0].manual_form_link;
            }
          }
        } else {
          this.applyingBaa = 1;
          if (data && data.data[0]) {
            this.selected_location = {
              type: 'location',
              name: '',
              id: -1,
              ind_id: data.data[0].ind_id,
              bsa_form_type: data.data[0].bsa_form_type
            }
            this.clinic = {
              doctor_name: data.data[0].doctor_first_name + " " + data.data[0].doctor_last_name,
              doctor_date_display: moment(new Date()).format("MM/DD/yyyy"),
              doctor_address: data.data[0].practice_address,
              doctor_city: data.data[0].city,
              doctor_state: data.data[0].state_name,
              doctor_zip: data.data[0].zip,
              doctor_email: data.data[0].practice_email || data.data[0].doctor_email,
              doctor_mobile: data.data[0].practice_mobile || data.data[0].doctor_mobile,
              doctor_signature: null,
              manual_form_link: null,
              clinic_name: data.data[0].practice_name,
              doctor_salutation: data.data[0].title || '',
              doctor_title: data.data[0].title || ''
            };
            console.log(this.clinic, this.selected_location)
          } else if (this.userProfileData.length > 0 && this.userProfileData[0].role_id == 4) {
            this.clinic = {
              doctor_name: this.userProfileData[0].doctor_first_name + " " + this.userProfileData[0].doctor_last_name,
              doctor_date_display: moment(new Date()).format("MM/DD/yyyy"),
              doctor_address: this.userProfileData[0].practice_address,
              doctor_city: this.userProfileData[0].city,
              doctor_state: this.userProfileData[0].state_name,
              doctor_zip: this.userProfileData[0].zip,
              doctor_email: this.userProfileData[0].practice_email || this.userProfileData[0].doctor_email,
              doctor_mobile: this.userProfileData[0].practice_mobile || this.userProfileData[0].doctor_mobile,
              doctor_signature: null,
              manual_form_link: null,
              clinic_name: this.userProfileData[0].practice_name,
              doctor_salutation: this.userProfileData[0].title || '',
              doctor_title: this.userProfileData[0].title || ''
            };
          } else if (localStorage.getItem('locations') && this.selected_location.id) {
            let locations = getStoredLocations();
            let location = locations.filter(location => location.doctor_id == this.selected_location.id);
            this.clinic = {
              doctor_name: location[0].doctor_first_name + " " + location[0].doctor_last_name,
              doctor_date_display: moment(new Date()).format("MM/DD/yyyy"),
              doctor_address: location[0].practice_address,
              doctor_city: location[0].city,
              doctor_state: location[0].state_name,
              doctor_zip: location[0].zip,
              doctor_email: location[0].practice_email || location[0].doctor_email,
              doctor_mobile: location[0].practice_mobile || location[0].doctor_mobile,
              doctor_signature: null,
              manual_form_link: null,
              clinic_name: location[0].practice_name,
              doctor_salutation: location[0].title || '',
              doctor_title: location[0].title || ''
            };
          }
        }
        setTimeout(() => {
          if (this.applyingBaa == 1) {
            if (document.getElementById('canvas-id1')) {
              this.canvasWidth = (document.getElementById('canvas-id1').offsetWidth) * 0.95
            } else if (document.getElementById('canvas-id')) {
              this.canvasWidth = (document.getElementById('canvas-id').offsetWidth) * 0.95
            }
            this.show_sign = true;
          }
        }, 500);
      });
  }

  public clear() {
    this.sigs.first.clear();
  }

  clientFormSubmit() {
    if (!this.signatureField) {
      this.mainService.customPopups('Enter a valid signature', 1);
      return false;
    }

    if (this.selected_location.bsa_form_type == 2) {
      if (!this.clinic.doctor_name || this.clinic.doctor_name.trim().length == 0) {
        this.mainService.customPopups('Enter a valid business name', 1);
        return false;
      }
      if (!this.clinic.doctor_title || this.clinic.doctor_title.trim().length == 0) {
        this.mainService.customPopups('Enter a valid title', 1);
        return false;
      }
      if (!this.clinic.clinic_name || this.clinic.clinic_name.trim().length == 0) {
        this.mainService.customPopups('Enter a valid company name', 1);
        return false;
      }
    }

    var form = new FormData();
    form.append('access_token', localStorage.getItem('token') || this.ac_tk);
    form.append('doctor_address', this.clinic.doctor_address);
    form.append('doctor_city', this.clinic.doctor_city);
    form.append('doctor_state', this.clinic.doctor_state);
    form.append('doctor_zip', this.clinic.doctor_zip);
    form.append('doctor_email', this.clinic.doctor_email);
    form.append('doctor_mobile', this.clinic.doctor_mobile);
    form.append('doctor_name', this.clinic.doctor_name);
    form.append('doctor_date', moment(new Date()).format('YYYY-MM-DD hh:mm:ss'));
    form.append('doctor_signature', this.signatureField);
    if (this.selected_location && this.selected_location.id) {
      form.append('doctor_id', String(this.selected_location.id));
    }
    if (this.selected_location.bsa_form_type == 2) {
      form.append('doctor_clinic_name', this.clinic.clinic_name);
      form.append('doctor_title', this.clinic.doctor_title);
      form.append('doctor_salutation', this.clinic.doctor_salutation != "None" ? this.clinic.doctor_salutation : '');
    }
    this.mainService.uploadApi(form, 'baa_form', true)
      .subscribe((data: any) => {
        if (data.is_error == 0) {
          this.getFormDetails();
        }
      });
  };

  generateHSAPDF() {
    var vendor_date_display = this.vendor.vendor_date_display ? this.vendor.vendor_date_display : '';
    var html = '<!DOCTYPE html>\n' +
      '<html>\n' +
      '<head><title>HSA Form</title>' +
      '<link rel="stylesheet" type="text/css" href="https://business.denefits.com/app/css/bootstrap.css">' +
      '<link rel="stylesheet" type="text/css" href="https://business.denefits.com/app/css/custom.css">' +
      '<link rel="stylesheet" type="text/css" href="https://business.denefits.com/app/css/customMedia.css">' +
      '<link rel="stylesheet" type="text/css" href="https://business.denefits.com/app/css/theme-a.css">' +
      '<link rel="stylesheet" type="text/css" href="https://business.denefits.com/app/css/pdf.css">' +
      '<style>*{font-family: \'ProximaNova-Bold\', Helvetica, Arial, serif;} .A4{page-break-after: always;} .signButtons {' +
      'display: none;' +
      '}.form-group {' +
      'display: table;' +
      'width: 100% ;' +
      'padding: 0!important;' +
      '}.content {' +
      'padding-right: 40px !important;' +
      '} </style>' +
      '</head>\n' +
      '<body onload="setData();">' + document.getElementById('A4').innerHTML +
      '<script>\nwindow.onload = setData();\nfunction setData(){\n' +
      'var elems = document.querySelectorAll(".salutation");' +

      '[].forEach.call(elems, function (el) {' +
      'el.classList.remove("col-xs-8");' +
      'el.classList.add("col-xs-3");' +
      '});' +
      'var elems2 = document.querySelectorAll(".salutationInput");' +

      '[].forEach.call(elems2, function (el) {' +
      'el.classList.remove("col-xs-8");' +
      'el.classList.add("col-xs-4");' +
      '});' +
      'document.getElementById("vendor_name").value= "' + (this.vendor.vendor_name ? this.vendor.vendor_name : '') + '";\n' +
      'document.getElementById("vendor_name").placeholder= "";\n' +
      'document.getElementById("vendor_title").value= "' + (this.vendor.vendor_title ? this.vendor.vendor_title : '') + '";\n' +
      'document.getElementById("vendor_title").placeholder= "";\n';
    if (!this.vendor.support_salutation) {
      html += 'document.getElementById("support_salutation").value= "";\n';
    } else
      html += 'document.getElementById("support_salutation").value= ' + (this.vendor.vendor ? '"' + this.vendor.support_salutation + '";' : '"";') + '\n';
    if (!this.vendor.support_signature) {
      html += 'document.getElementById("vendor_sign").value= "";\n' +
        'document.getElementById("vendor_sign").placeholder= "";\n';
    }

    html += 'document.getElementById("vendor_date_display").value= "' + vendor_date_display + '";\n' +
      'document.getElementById("vendor_date_display").placeholder= "";\n' +
      '}</script>' +
      '</body>\n' +
      '</html>';
    var w = window.open("", "", "width=800,height=1150");
    w.document.write(html);
    setTimeout(() => {
      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
        w.location.reload();
      }
      w.focus();
      w.print();
    }, 3000);
  };

  generatePDF() {
    var vendor_date_display = this.vendor.vendor_date_display ? this.vendor.vendor_date_display : '';
    var html = '<!DOCTYPE html>\n' +
      '<html>\n' +
      '<head><title>BSA Form</title>' +
      '<link rel="stylesheet" type="text/css" href="https://business.denefits.com/app/css/bootstrap.css">' +
      '<link rel="stylesheet" type="text/css" href="https://business.denefits.com/app/css/custom.css">' +
      '<link rel="stylesheet" type="text/css" href="https://business.denefits.com/app/css/customMedia.css">' +
      '<link rel="stylesheet" type="text/css" href="https://business.denefits.com/app/css/theme-a.css">' +
      '<link rel="stylesheet" type="text/css" href="https://business.denefits.com/app/css/pdf.css">' +
      '<style>*{font-family: \'ProximaNova-Bold\', Helvetica, Arial, serif;} .A4{page-break-after: always;} .signButtons {' +
      'display: none;' +
      '}.form-group {' +
      'display: table;' +
      'width: 100% ;' +
      'padding: 0!important;' +
      '} </style>' +
      '</head>\n' +
      '<body onload="setData();">' + document.getElementById('A4').innerHTML +
      '<script>\nwindow.onload = setData();\nfunction setData(){\n' +
      'var elems = document.querySelectorAll(".salutation");' +

      '[].forEach.call(elems, function (el) {' +
      'el.classList.remove("col-xs-8");' +
      'el.classList.add("col-xs-3");' +
      '});' +
      'var elems2 = document.querySelectorAll(".salutationInput");' +

      '[].forEach.call(elems2, function (el) {' +
      'el.classList.remove("col-xs-8");' +
      'el.classList.add("col-xs-5");' +
      '});' +
      'document.getElementById("clinic_name").value= "' + (this.clinic.clinic_name ? this.clinic.clinic_name : '') + '";\n' +
      'document.getElementById("doctor_name").value= "' + (this.clinic.doctor_name ? this.clinic.doctor_name : '') + '";\n' +
      'document.getElementById("doctor_title").value= "' + (this.clinic.doctor_title ? this.clinic.doctor_title : '') + '";\n' +
      'document.getElementById("doctor_date").value= "' + (this.clinic.doctor_salutation ? this.clinic.doctor_salutation : '') + '";\n' +
      'document.getElementById("doctor_date").value= "' + (this.clinic.doctor_date_display ? this.clinic.doctor_date_display : '') + '";\n' +
      'document.getElementById("vendor").value= "' + (this.vendor.vendor ? this.vendor.vendor : '') + '";\n' +
      'document.getElementById("vendor").placeholder= "";\n' +
      'document.getElementById("vendor_name").value= "' + (this.vendor.vendor_name ? this.vendor.vendor_name : '') + '";\n' +
      'document.getElementById("vendor_name").placeholder= "";\n' +
      'document.getElementById("vendor_title").value= "' + (this.vendor.vendor_title ? this.vendor.vendor_title : '') + '";\n' +
      'document.getElementById("vendor_title").placeholder= "";\n';
    if (!this.vendor.support_salutation) {
      html += 'document.getElementById("support_salutation").value= "";\n';
    } else
      html += 'document.getElementById("support_salutation").value= ' + (this.vendor.vendor ? '"' + this.vendor.support_salutation + '";' : '"";') + '\n';
    if (!this.vendor.support_signature) {
      html += 'document.getElementById("vendor_sign").value= "";\n' +
        'document.getElementById("vendor_sign").placeholder= "";\n';
    }

    html += 'document.getElementById("vendor_date_display").value= "' + vendor_date_display + '";\n' +
      'document.getElementById("vendor_date_display").placeholder= "";\n' +
      '}</script>' +
      '</body>\n' +
      '</html>';
    var w = window.open("", "", "width=800,height=1150");
    w.document.write(html);
    setTimeout(() => {
      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
        w.location.reload();
      }
      w.focus();
      w.print();
    }, 3000);
  };

  routeMe(data) {
    this._router.navigate([data]);
  }

  ngOnDestroy() {
    this.locationSubscription && this.locationSubscription.unsubscribe();
    this.salutations_subscription && this.salutations_subscription.unsubscribe();
  }
}
